import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateCreditLimitIncreasePreference() {
  const put = usePut(true, "ams");
  const updateCreditLimitIncreasePreference = async (accountId: string, newCreditLimitIncreasePreference: string) => {
    return await put(`/api/proxy/ams/account-service/account/${accountId}/credit-limit-increase-preference`, {
        newCreditLimitIncreasePreference: newCreditLimitIncreasePreference
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, newCreditLimitIncreasePreference }: { accountId: string, newCreditLimitIncreasePreference: string }) =>
      updateCreditLimitIncreasePreference(accountId, newCreditLimitIncreasePreference),
  });
}
